import { render, staticRenderFns } from "./NoteDialog.vue?vue&type=template&id=fb591f3c&scoped=true&"
import script from "./NoteDialog.vue?vue&type=script&lang=js&"
export * from "./NoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoteDialog.vue?vue&type=style&index=0&id=fb591f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb591f3c",
  null
  
)

export default component.exports